
export const NoYet =({text, styles})=>{
    return(
        <div className='not-yet-box'>
          <p style={{...styles}}>{text}</p>
        </div>
    )
}